"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeFilterContext = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var flatMap_1 = tslib_1.__importDefault(require("lodash/flatMap"));
var zip_1 = tslib_1.__importDefault(require("lodash/zip"));
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_model_1 = require("@gooddata/sdk-model");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
/**
 * Since bear backend does not support idRefs in filter context objects, we need to covert them to uriRefs if they are present.
 *
 * @param filterContext - filter context to sanitize
 * @param objRefsToUris - function converting ObjRefs to URIs
 * @returns filter context that uses uriRefs exclusively in its filters
 */
function sanitizeFilterContext(filterContext, objRefsToUris) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var filters, refs, convertedRefs, refUriPairs, sanitizedFilters;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    filters = filterContext.filters;
                    if (!filters.length) {
                        return [2 /*return*/, filterContext];
                    }
                    refs = compact_1.default(flatMap_1.default(filters, function (filter) {
                        var _a;
                        var ref = getDashboardFilterRef(filter);
                        var overRefs = sdk_backend_spi_1.isDashboardAttributeFilter(filter)
                            ? flatMap_1.default((_a = filter.attributeFilter.filterElementsBy) !== null && _a !== void 0 ? _a : [], function (item) { return item.over.attributes; })
                            : [];
                        return tslib_1.__spreadArrays([ref], overRefs);
                    }));
                    return [4 /*yield*/, objRefsToUris(refs)];
                case 1:
                    convertedRefs = _a.sent();
                    refUriPairs = zip_1.default(refs, convertedRefs);
                    sanitizedFilters = filters.map(function (filter) {
                        var _a;
                        var originalRef = getDashboardFilterRef(filter);
                        if (!originalRef) {
                            return filter;
                        }
                        // we can use referential comparison here, the objects are the same
                        var refMatch = refUriPairs.find(function (_a) {
                            var ref = _a[0];
                            return ref === originalRef;
                        });
                        // this indicates a serious fault in the logic
                        ts_invariant_1.default(refMatch);
                        var sanitizedRef = sdk_model_1.uriRef(refMatch[1]);
                        if (sdk_backend_spi_1.isDashboardAttributeFilter(filter)) {
                            var sanitizedFilterElementsBy = (_a = filter.attributeFilter.filterElementsBy) === null || _a === void 0 ? void 0 : _a.map(function (item) { return (tslib_1.__assign(tslib_1.__assign({}, item), { over: tslib_1.__assign(tslib_1.__assign({}, item.over), { attributes: item.over.attributes.map(function (attrRef) {
                                        // we can use referential comparison here, the objects are the same
                                        var attrMatch = refUriPairs.find(function (_a) {
                                            var ref = _a[0];
                                            return ref === attrRef;
                                        });
                                        // this indicates a serious fault in the logic
                                        ts_invariant_1.default(attrMatch);
                                        return sdk_model_1.uriRef(attrMatch[1]);
                                    }) }) })); });
                            return {
                                attributeFilter: tslib_1.__assign(tslib_1.__assign({}, filter.attributeFilter), { displayForm: sanitizedRef, filterElementsBy: sanitizedFilterElementsBy }),
                            };
                        }
                        else {
                            return {
                                dateFilter: tslib_1.__assign(tslib_1.__assign({}, filter.dateFilter), { dataSet: sanitizedRef }),
                            };
                        }
                    });
                    return [2 /*return*/, tslib_1.__assign(tslib_1.__assign({}, filterContext), { filters: sanitizedFilters })];
            }
        });
    });
}
exports.sanitizeFilterContext = sanitizeFilterContext;
function getDashboardFilterRef(filter) {
    return sdk_backend_spi_1.isDashboardAttributeFilter(filter)
        ? filter.attributeFilter.displayForm
        : filter.dateFilter.dataSet;
}
//# sourceMappingURL=filterContexts.js.map